import React, {useContext} from 'react'
import {Route, Navigate} from "react-router";
import {AppContext} from "../../context/app-context";
import {withAccessControl} from "../ProtectedRoute";
import AccessControlBuilder from "../AccessControlBuilder";
import {useFeatureFlags} from "../../hooks/routing/useFeatureFlags";

import LocationsBuyerSummary from "../../views/location/buyer-summary/LocationsBuyerSummary/LocationsBuyerSummary";
import LocationsProfile from "../../views/LocationsProfile";
import AccountOverview from '../../views/account-overview/AccountOverview';
import CreateLocationWizard from '../../views/create-location-wizard/CreateLocationWizard';
import  LocationsProfileRedesign from "../../views/LocationsProfile/LocationsProfile";

interface AccessControl {
  userTypes: string[];
  accountTypes: string[];
  subscriptionTypes: string[];
  additionalValidation?: (user: object) => boolean;
}

const allOwnerAuthorization: AccessControl = new AccessControlBuilder().allowAllOwners().build();

const supplierOwnerOrGateManagerAuth: AccessControl = new AccessControlBuilder()
  .allowAllSupplierOwner()
  .allowGateManager()
  .build();

const buyerOrGateManagerAuth: AccessControl = new AccessControlBuilder()
  .allowAllBuyer()
  .allowGateManager()
  .build();

const ProtectedLocationsProfile = withAccessControl(LocationsProfile, supplierOwnerOrGateManagerAuth);
const ProtectedLocationsProfileRedesign = withAccessControl(LocationsProfileRedesign, supplierOwnerOrGateManagerAuth);
const ProtectedLocationsBuyerSummary = withAccessControl(LocationsBuyerSummary, buyerOrGateManagerAuth);
const ProtectedNotificationSettings = withAccessControl(AccountOverview, allOwnerAuthorization);
const ProtectedAccountOverview = withAccessControl(AccountOverview, allOwnerAuthorization);
const ProtectedCreateLocationWizard = withAccessControl(CreateLocationWizard, supplierOwnerOrGateManagerAuth);

const AccountContent = () => {
  const appContext = useContext(AppContext);
  const {updateUser} = appContext;

  const { createLocationWizard, manageLocationsRedesign } = useFeatureFlags();

  return [
    <Route path="/company-profile" key="/company-profile" element={<Navigate to='/account/company-profile'/>}></Route>,
    <Route path="/locations-profile" key="/locations-profile" element={
      manageLocationsRedesign ? <ProtectedLocationsProfileRedesign/> : <ProtectedLocationsProfile/>
    }></Route>,
    <Route path="/locations/create" key="/locations/create" element={
      createLocationWizard ? <ProtectedCreateLocationWizard/> : <Navigate to='/locations-profile'/>
    }></Route>,
    <Route path="/locations/:locationId/edit" key="/locations/:locationId/edit" element={
      createLocationWizard ? <ProtectedCreateLocationWizard/> : <Navigate to='/locations-profile'/>
    }></Route>,
    <Route path="/account/my-locations" key="/account/my-locations"
           element={<ProtectedLocationsBuyerSummary/>}> </Route>,
    <Route path="/user-management" key="/user-management" element={<Navigate to='/account/user-management'/>}></Route>,
    <Route path="/payment-methods" key="/payment-methods" element={<Navigate to='/account/payment-methods'/>}></Route>,

    <Route path="/notification-settings" key="/notification-settings"
           element={<Navigate to='/account/notification-settings'/>}>
    </Route>,

    <Route path="/account/company-profile" key="/account/company-profile" element={
      <ProtectedAccountOverview
        handleAccountUpdated={updateUser}
        initialTab={'company'}
      />}>
    </Route>,

    <Route path="/account/user-management" key="/account/user-management"
           element={<ProtectedAccountOverview handleAccountUpdated={updateUser}
                                              initialTab={'users'}/>}> </Route>,
    <Route path={"/account/payment-methods"} key={"/account/payment-methods"}
           element={<ProtectedAccountOverview handleAccountUpdated={updateUser}
                                              initialTab={'payment'}/>}> </Route>,
    <Route path="/account/notification-settings" key="/notification-settings"
           element={<ProtectedNotificationSettings handleAccountUpdated={updateUser}
                                                   initialTab={'notifications'}/>}> </Route>,
  ];
}

export default AccountContent;
